export var GetEligibilityRequestEnum;
(function (GetEligibilityRequestEnum) {
    GetEligibilityRequestEnum["ByCandidate"] = "ByCandidate";
})(GetEligibilityRequestEnum || (GetEligibilityRequestEnum = {}));
//# sourceMappingURL=price-drop.js.map